<template>
  <ul-editor
    :key="editorOptions.language"
    :height="height"
    ref="myMceEditor"
    v-model="content"
    :allowPaste="allowPaste"
    :toolbarOptions="toolbarOptions"
    :options="editorOptions"
    @change="onChange"
    :uploaderConfig="{
      authorization: token,
      uptokenHost: COURSE_API_HOST,
      obsHost: RESOURCE_SERVER_HOST,
      config: {
        uphost: UPLOAD_SERVER_HOST,
        upprotocol: UPLOAD_SERVER_PROTOCOL,
      },
    }"
  >
  </ul-editor>
</template>

<script>
import { mapGetters } from "vuex";
import UlEditor from "ulearning-ui/packages/editor"; // 下载依赖后修改编辑组件的obs引用
import {
  COURSE_API_HOST,
  RESOURCE_SERVER_HOST,
  UPLOAD_SERVER_HOST,
  UPLOAD_SERVER_PROTOCOL,
} from "@/config";
export default {
  name: "editor",
  components: {
    UlEditor,
  },
  props: {
    value: String,
    height: {
      type: Number,
      default: 500,
    },
    // 是否允许粘贴
    allowPaste: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value() {
      this.content = this.value;
    },
  },
  computed: {
    ...mapGetters({ token: "user/token" }),
    editorOptions() {
      const locale = this.$i18n.locale || 'zh';
      const isZh = locale.indexOf('zh') > -1;
      
      const langMap = {
        'zh': 'zh_CN',
        'tw': 'zh_TW',
        'en': 'en',
        'es': 'es',
        'ar': 'ar',
        'id': 'id',
        'th': 'th_TH'
      };
      const lang = langMap[locale] || 'en';
      
      const fontFormats = isZh 
        ? "微软雅黑=Microsoft YaHei;苹果苹方=PingFang SC;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei, sans-serif;Arial=arial, helvetica, sans-serif;Arial Black=arial black, avant garde;Times New Roman=times new roman,times;"
        : "Microsoft YaHei=Microsoft YaHei;PingFang SC=PingFang SC;SimSun=simsun,serif;FangSong=FangSong,serif;SimHei=SimHei, sans-serif;Arial=arial, helvetica, sans-serif;Arial Black=arial black, avant garde;Times New Roman=times new roman,times;";

      let options = {
        font_formats: fontFormats,
        language: lang,
      };
      
      if (lang === 'en') {
        options.language_url = undefined;
      } else {
        options.language_url = `editorLib/tinymce/langs/${lang}.js`;
      }
      
      return options;
    }
  },
  data() {
    return {
      COURSE_API_HOST: COURSE_API_HOST,
      RESOURCE_SERVER_HOST: RESOURCE_SERVER_HOST,
      UPLOAD_SERVER_HOST: UPLOAD_SERVER_HOST,
      UPLOAD_SERVER_PROTOCOL: UPLOAD_SERVER_PROTOCOL,
      content: "",
      toolbarOptions:
        "fontselect | fontsizeselect | bold italic underline forecolor | numlist bullist alignleft | superscript subscript table formula imageupload",
    };
  },
  created() {},
  mounted() {
    if (this.value) {
      this.$nextTick(() => {
        this.content = this.value;
      });
    }
  },
  methods: {
    onChange() {
      this.$emit("onChange", this.content);
    },
  },
};
</script>

<style lang="scss">
.tox-toolbar {
  .tox-toolbar__group:nth-child(1) {
    .tox-tbtn__select-label {
      width: 4em;
    }
  }
  .tox-toolbar__group:nth-child(2) {
    .tox-tbtn__select-label {
      width: 3em;
    }
  }
}
</style>